import { useRuntimeConfig } from '#imports';
import { DEFAULT_PATH } from '~/plugins/authorization.client';
import CookieHelper from '~/helpers/CookieHelper';
import ErrorHelper from '~/helpers/ErrorHelper';
import NdGroupService from '~/services/NdGroupService';

export default class User {
  private static TOKEN_COOKIE_NAME = 'token';
  private static GROUP_HASH_COOKIE_NAME = 'gh';

  public static isAuthenticated(): boolean {
    return Boolean(this.getToken());
  }

  public static getToken(): string {
    return CookieHelper.getValue(this.TOKEN_COOKIE_NAME) ?? '';
  }

  public static getGroupHash(): string {
    return CookieHelper.getValue(this.GROUP_HASH_COOKIE_NAME) ?? '';
  }

  public async authenticate(token: string, groupHash: string) {
    try {
      const { data } = await (await this.getApiClient()).validateToken(token);
      this.setToken(data.token);
      this.setGroupHash(groupHash);
      if (!await NdGroupService.isSynchronized(groupHash, token === 'dev')) {
        throw new Error('Group you belong to is not synchronised');
      }
      return navigateTo(DEFAULT_PATH);
    } catch (e: unknown) {
      ErrorHelper.throwInvalidTokenError(e);
    }
  }

  public async keepAlive() {
    if (User.isAuthenticated()) {
      await (await this.getApiClient()).keepAlive();
    }
  }

  public refreshSession(newToken: string) {
    this.setToken(newToken);
    this.setGroupHash(User.getGroupHash());
  }

  public removeCookies() {
    CookieHelper.remove(User.TOKEN_COOKIE_NAME);
    CookieHelper.remove(User.GROUP_HASH_COOKIE_NAME);
  }

  private async getApiClient() {
    //TODO: fix circular dependency [AuthApiClient <-> User]
    const apiClientClass = await import('~/apiClients/AuthApiClient');
    const AuthApiClient = apiClientClass.default;
    return new AuthApiClient();
  }

  private setGroupHash(groupHash: string) {
    const isGroupHashDefined = groupHash && 'undefined' !== groupHash;
    const finalGroupHash = isGroupHashDefined ? groupHash : useRuntimeConfig().public.defaultGroupHash;
    CookieHelper.set(User.GROUP_HASH_COOKIE_NAME, finalGroupHash);
  }

  private setToken(jwt: string) {
    CookieHelper.set(User.TOKEN_COOKIE_NAME, jwt);
  }
}
